import React from 'react'
import PropTypes from 'prop-types'

import { makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  singleValue: {
    fontSize: '0.875rem',
    padding: '3px 8px'
  }
}))

const SingleValue = props => {
  const classes = useStyles()

  return (
    <Typography className={classes.singleValue} {...props.innerProps}>
      {props.children}
    </Typography>
  )
}

SingleValue.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.object,
  selectProps: PropTypes.object.isRequired
}

export default SingleValue
